import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionDefinition, OptionsDictionary } from './SortOptionDefinitions';

export const workbookNameSortOption: OptionDefinition = {
  id:'workbook',
  getMenuItemDisplayValue: Messages.column_workbook,
  subSortOptions: {
    'asc': {
      id: 'workbook.asc',
      field: OrderKeys.workbookName,
      getMenuItemDisplayValue: Messages.sortByAZ,
      getButtonDisplayValue: Messages.sortByWorkbookAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.workbookName), Order.asc(OrderKeys.name)]
    },
    'desc': {
      id: 'workbook.desc',
      field: OrderKeys.workbookName,
      getMenuItemDisplayValue: Messages.sortByZA,
      getButtonDisplayValue: Messages.sortByWorkbookDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.workbookName), Order.asc(OrderKeys.name)]
    }
  }
};

export const viewSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'workbook': workbookNameSortOption,
  'sheet': SortOptions.sheetIndex,
  'locationName': SortOptions.locationName,
  'owner': SortOptions.owner,
  'updated': SortOptions.updated
};
